import React from "react";
import { Link } from "react-router-dom";
import { PRICING } from "../data/pricing";
import PricingCard from "./PricingCard";

const ModulePricingSummary = ({ moduleKey }) => {
  const data = PRICING[moduleKey];
  if (!data) return null;
  const colsClass = data.tiers.length === 2 ? "cols-2" : data.tiers.length === 3 ? "cols-3" : "";

  return (
    <section
      className="mk-section soft mk-module-pricing"
      data-testid="module-pricing-summary"
      data-module-key={moduleKey}
    >
      <div className="mk-wrap">
        <div className="mk-section-head mk-reveal">
          <div>
            <h2>Tarifs {data.label}</h2>
            <p style={{ marginTop: "12px", color: "#647286", lineHeight: 1.66, maxWidth: 540 }}>
              Démarrez avec la formule qui correspond à votre volume, ajustez à mesure que votre activité scale.
            </p>
          </div>
        </div>

        <div
          className={`mk-pricing-grid ${colsClass}`}
          data-testid="module-pricing-grid"
        >
          {data.tiers.map((tier) => (
            <PricingCard
              key={tier.key}
              moduleKey={moduleKey}
              moduleLabel={data.label}
              tier={tier}
            />
          ))}
        </div>

        <p className="mk-pricing-note" style={{ marginTop: 20, textAlign: "center", color: "#68768b" }}>
          Voir tous les tarifs <Link to="/#tarifs" style={{ color: "#3858ff", fontWeight: 800 }}>sur la page d'accueil</Link>.
        </p>
      </div>
    </section>
  );
};

export default ModulePricingSummary;
